module.exports = __webpack_public_path__ + "static/img/customer8.1ba75b3c.png";